import "./Home.module.css";
import MainHeader from "@/reusable_sections/Header";
import TheMasterstroke from "./sections/TheMasterstroke";
import TheGuardianDifference from "./sections/TheGuardianDifference";
import ExteriorMastery from "./sections/ExteriorMastery";
import ExpertStructureRemoval from "./sections/ExpertStructureRemoval";
import ThePortfolio from "./sections/ThePortfolio";
import GlobalSupportHub from "./sections/GlobalSupportHub";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainHeader />
      <TheMasterstroke />
      <TheGuardianDifference />
      <ExteriorMastery />
      <ExpertStructureRemoval />
      <ThePortfolio />
      <GlobalSupportHub />
      <Footer />
    </div>;
}